import { render, staticRenderFns } from "./editOrNewFo.vue?vue&type=template&id=1268d3eb&scoped=true&"
import script from "./editOrNewFo.vue?vue&type=script&lang=js&"
export * from "./editOrNewFo.vue?vue&type=script&lang=js&"
import style0 from "./editOrNewFo.vue?vue&type=style&index=0&id=1268d3eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268d3eb",
  null
  
)

export default component.exports